<template lang="pug">
.log-entry
    .flex-row
        a.status.circle.fi.fis(
            v-if="log.data"
            href="#"
            :class="log.status"
            @click.prevent="drawer.visibility = !drawer.visibility"
        )
            i.fas.el-icon-fa-question
        .status.circle.fi.fis(v-else :class="log.status")
        //- .id {{ log.id }}
        .info.grow
            .heading(v-if="log.heading" :title="log.heading") {{ log.heading }}
            .body(v-if="log.body" :title="log.body") {{ log.body }}
            .exception(v-if="exception" :title="exception") {{ exception }}
        component.context(:is="component" v-bind="props" :title="contextTitle" @click="handleClick")
            .file(v-if="log.file") {{ log.file.preferred_name || log.file.name }}
            .purchase(v-if="log.purchase") {{ $t('Order \#{id}', { id: log.purchase.id  }) }}
            //- .category(v-else-if="log.shopCategory") {{ $t('Category \#{id}', { id: log.shopCategory.id  }) }}
            .category(v-else-if="log.shopCategory") {{ log.shopCategory.name }}
        transition(name="fade" mode="out-in")
            //- .done(v-if="log.progress === 100")
            //-     //- i.el-icon-fa-check.fas
            //-     span 100%
            .percentage(v-if="log.progress != null" :class="{ complete: log.progress >= 100 }")
                span {{ log.progress | round(2) }}%
        //- What the run actually cost, once fal.ai's billing event has been reconciled
        //- (a few minutes after completion) — null for anything that isn't a
        //- generative-media run.
        .incurred-cost(v-if="log.incurred_cost_pending") {{ $t('being calculated') }}
        .incurred-cost(v-else-if="log.incurred_cost != null") {{ log.incurred_cost | moneyFormat('EUR') }}
        .timestamp {{ log.updated_at | timestamp2date(dateTimeFormat) }}
        slot(name="actions")
    transition(name="slide-decent-vertical" mode="out-in")
        .progress(v-if="log.status !== 'error' && log.progress > 0 && log.progress < 100")
            el-progress(
                :percentage="log.progress"
                :show-text="false"
            )
    el-drawer(
        :visible.sync="drawer.visibility"
        :append-to-body="true"
        :modal="true"
        :with-header="false"
        size="680px"
    )
        monaco-editor(
            language="json"
            :read-only="true"
            :value="JSON.stringify(JSON.parse(log.data), null, 2)"
        )
</template>

<i18n>
{
    "en": {
        "Order #{id}": "Order #{id}",
        "Category #{id}": "Category #{id}",
        "Category \\#{id}": "Category \\#{id}",
        "Order \\#{id}": "Order \\#{id}"
    },
    "de": {
        "Order #{id}": "Bestellung #{id}",
        "Category #{id}": "Kategorie #{id}",
        "being calculated": "wird berechnet"
    }
}
</i18n>

<script>
import { timestamp2date } from '@/filters'
import echo from '@/echo';

import AuthApi from '@/store/api/system/auth';

import MonacoEditor from '@/components/MonacoEditor'

export default {
    name: 'StatusLog',
    props: {
        log: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            drawer: {
                visibility: false,
            },
        }
    },
    components: {
        MonacoEditor,
    },
    filters: {
        timestamp2date,
    },
    computed: {
        component() {
            let component

            if (this.log.file) {
                component = 'a';
            } else if (this.log.purchase || this.log.shopCategory) {
                component = 'router-link';
            }

            return component;
        },
        props() {
            let props = {};

            if (this.log.file) {
                const file = this.log.file

                let storageRoute = _.trim(
                    `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
                    '/'
                );
                const table = 'files';
                const token = AuthApi.getToken();
                let link = `${storageRoute}/${table}/${file.id}/${encodeURIComponent(file.name)}?download&token=${token}`

                props.href = link;
                props.download = this.log.file.preferred_name || true;
            } else if (this.log.purchase) {
                props.to = { name: 'purchase-form', params: { id: this.log.purchase.id } };
            } else if (this.log.shopCategory) {
                props.to = { name: 'category-form-item', params: { id: this.log.shopCategory.id } };
            }

            return props
        },
        contextTitle() {
            if (this.log.file) return this.log.file.preferred_name || this.log.file.name;
            if (this.log.shopCategory) return this.log.shopCategory.name;
            return undefined;
        },
        exception() {
            const data = JSON.parse(this.log.data)
            return _.get(data, 'exception')
        },
        dateTimeFormat() {
            const template = this.$t('yyyy-MM-dd')
            return `${template}, HH:mm`
        },
    },
    methods: {
        handleClick(event) {
            if (this.log.file) {
                const token = AuthApi.getToken();
                event.target.href = event.target.href.replace(/token=[^&]+/, 'token=' + token);
            }
        },
    },
    // mounted () {
    //     echo.client.private('status-log.' + this.log.id)
    //         .listen('.status-log:updated', data => {
    //             // if (data.job && ['export:stock'].includes(data.job.type)) {
    //             //     commit('updateUnfinishedJob', data.job);
    //             // }
    //         })
    // },
    // beforeDestroy() {
    //     echo.client.private(`status-log.${this.log.id}`)
    //         .stopListening('.status-log:updated')
    // },
}
</script>

<style lang="sass" scoped>
// One line per run. The heading and the body share what the fixed columns leave and are
// cut with an ellipsis (full text on hover); the percentage, cost and time never shrink
// and use tabular figures, so they line up from row to row.
.log-entry
    padding: 0.5rem 1rem
    .flex-row
        align-items: center
        gap: 0.75rem
    .info.grow
        display: flex
        align-items: baseline
        gap: 0.75rem
        flex: 1 1 auto
        min-width: 0
    .heading
        flex: 0 1 auto
        max-width: 60%
        min-width: 0
        font-weight: 500
    .body, .exception
        flex: 1 1 0
        min-width: 3ch
    .heading, .body, .exception
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
    .context
        flex: 0 1 auto
        max-width: 30%
        min-width: 0
        & > *
            overflow: hidden
            text-overflow: ellipsis
    .percentage, .incurred-cost, .timestamp
        flex-shrink: 0
        font-variant-numeric: tabular-nums
    .percentage
        min-width: 4.5ch
        text-align: right
    .progress
        margin-top: 6px
    a
        text-decoration: none

    &::v-deep
        .el-progress-bar__outer
            height: 4px !important

.exception
    color: $--color-danger
    font-weight: 600

// Narrow widget: the body moves under the heading instead of being squeezed to nothing
@container (max-width: 420px)
    .log-entry
        .info.grow
            flex-direction: column
            align-items: stretch
            gap: 0
        .heading
            max-width: 100%
        // a zero flex basis would collapse them to no height in a column
        .body, .exception
            flex: none
        // the status dot already says a finished run is done; the room goes to the heading
        .percentage.complete
            display: none

// .percentage
//     width: 6ch
//     // font-family: monospace

.file,
.heading,
.purchase,
.timestamp,
.category,
.incurred-cost
    white-space: nowrap

.incurred-cost
    font-size: 12px
    color: $--color-text-secondary

a
    .file,
    .heading,
    .purchase
        pointer-events: none


.monaco-editor-container
    // flex-grow: 1
    min-height: 100vh
    max-height: 100vh
    border-radius: 0
    resize: none
    background: #282c34
    color: white

.status
    width: 16px
    aspect-ratio: 1
    display: flex
    align-items: center
    justify-content: center
    border-radius: 20px
    font-size: 12px
    background: $--color-info
    color: white
    text-align: center
    padding: 0 !important
    flex-shrink: 0
    flex-grow: 0
    scale: 0.8
    &:before
        display: none
    &.info
        background: $--color-primary
    &.success
        background: $--color-success
    &.warning
        background: $--color-warning
    &.error,
    &.danger
        background: $--color-danger

a.status
    scale: 1.2

.done
    color: $--color-success
    font-weight: 600
    i
        margin-right: 0.5rem
        font-size: 1rem
        color: $--color-success
</style>
